import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/pages/Landing";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import ForgotPasswordPage from "@/pages/ForgotPassword";
import SurveyPage from "@/pages/Survey";
import CoachingDashboard from "@/pages/CoachingDashboard";
import ImmigrationDashboard from "@/pages/ImmigrationDashboard";
import AuthCallback from "@/pages/AuthCallback";
import AdminDashboard from "@/pages/AdminDashboard";
import { BlogListPage, BlogDetailPage } from "@/pages/Blog";
import CourseVideoPlayer from "@/pages/CourseVideoPlayer";
import EbookStore from "@/pages/EbookStore";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { WhatsappFloatingButton } from "@/components/WhatsappFloatingButton";
import { Toaster } from "@/components/ui/sonner";
import { initFirebase } from "@/lib/firebase";

initFirebase();

function InnerRoutes() {
  const location = useLocation();

  // CRITICAL: process OAuth session_id BEFORE anything else (during render)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/ebooks" element={<EbookStore />} />
      <Route path="/blog" element={<BlogListPage />} />
      <Route path="/blog/:slug" element={<BlogDetailPage />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute requireAdmin>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/survey"
        element={
          <ProtectedRoute>
            <SurveyPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/coaching"
        element={
          <ProtectedRoute requireSurvey={false}>
            <CoachingDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/immigration"
        element={
          <ProtectedRoute requireSurvey={false}>
            <ImmigrationDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/courses/:courseId"
        element={
          <ProtectedRoute>
            <CourseVideoPlayer />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<LandingPage />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <InnerRoutes />
          <WhatsappFloatingButton />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
